"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Coders = void 0;
const datetime_1 = require("./datetime");
const decimal_1 = require("./decimal");
const map_1 = require("./map");
exports.Coders = [
    datetime_1.DateTimeCoder,
    decimal_1.DecimalCoder,
    map_1.MapCoder
];
//# sourceMappingURL=index.js.map